import React, { useRef, useState, useEffect, useCallback, useImperativeHandle } from 'react';
import { Icon } from "@tencent/universe-ui/build/lib";
import { Stage, Layer, Image, Line } from 'react-konva';
import { Button, Input, Tooltip } from 'tdesign-react';
import { Html } from 'react-konva-utils';
import { getPositionRelativeToParent, cropToBase64 } from '../../utils/edu.js'

import useImage from 'use-image';
import useSmoothScroll from 'react-smooth-scroll-hook';
import { getScaleRatio, getImgNatural, getSum } from '../../utils/index.js';
const NumberReg = /^[0-9]+\.{0,1}[0-9]{0,2}$/;
const LayerImage = ({ src, width, height, x, y, rotation, offsetX, offsetY }) => {
  const [image] = useImage(src);
  return <Image
    rotation={rotation}
    offsetX={offsetX}
    offsetY={offsetY}
    image={image}
    width={width}
    height={height}
    y={y}
    x={x} />;
};
const resultingCom = (msg = '文件上传中...') => {
  return <>
    <div className="ocrDemo-resulting-container upload">
      <div className="ocrDemo-icon-resulting"></div>
      <div className="ocrDemo-resulting__text">{msg}</div>
    </div>
  </>
}
const ThumbnailPreview = ({
  isLoading = false,
  angle = 90,
  needClip = false,
  showLabel = false,
  rects = [],
  isShow = true,
  imageList = [],
  imageUrl,
  style,
  showZoomInIcon = true,
  showZoomOutIcon = true,
  showLeftIcon = true,
  showRightIcon = true,
  showZoomIcon = true,
  errorMsg = '图片无法显示',
  selectRect,
  onClip = () => { },
  onUpload = () => { },
  onSelect = () => { },
  onPageChange,
  cRef
}) => {
  useImperativeHandle(cRef, () => ({
    onPreChange: ({curImg,curpPdfList,imgSize}) => {
      setLoading(true);
      setCurDeg(0);
      setCurImgSize(imgSize);
      handleSetStageWidth(
        {
          imageUrl:curImg,
          imageList:curpPdfList,
          imgSize,
          sizes:{
            ...sizes,
            width: 100,
            height: 100,
            deg: 0,
          },
          imageBoxRef:imageBoxRef?.current,
          curDeg:curDeg
        })
      setLoading(false);
    },
    onRectChange: async (selectRect = selectRect) => {
    }
  }));

  const [loading, setLoading] = useState(true);
  const [curImgSize,setCurImgSize] = useState(null);
  const [targetHeight, setTargetHeight] = useState(0);
  const [targetWidth, setTargetWidth] = useState(0);
  const [isError, setIsError] = useState(false);
  const [showPdfPageControl, setShowPdfPageControl] = useState(false);
  const [imgList, setImgList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [inputVal, setInputVal] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [curDeg, setCurDeg] = useState(0);
  const [radio, setRadio] = useState(0); //  初始缩放比例
  const [stageInfo, setStageInfo] = useState({ //  图片初始信息
    width: 0,
    height: 0
  })
  const [containerImgInfo,setContainerImgInfo] = useState({ //  图片容器尺寸
    width: 0,
    height: 0
  })
  
  // 使用ref保存需要访问的state值，避免闭包问题
  const containerImgInfoRef = useRef(containerImgInfo);
  const imgListRef = useRef(imgList);
  const sizesRef = useRef(sizes);
  
  
  const [imgInfo, setImgInfo] = useState({ //  图片初始信息
    width: 0,
    height: 0
  })
  const [imgRotateInfo, setImgRotateInfo] = useState({ //  图片旋转信息
    rotation: 0,
    offsetX: 0,
    offsetY: 0
  })
  const [rotateInfo, setRotateInfo] = useState({ //  画布旋转信息
    rotation: 0,
    offsetX: 0,
    offsetY: 0
  })
  const imageBoxRef = useRef(document.body);
  const layerRef = useRef(null);

  const { scrollTo } = useSmoothScroll({
    ref: imageBoxRef,
    speed: 100,
    direction: 'y',
  });

  const [sizes, setSizes] = useState({
    originHeight: 0,
    originWidth: 0,
    width: 100,
    height: 100,
    deg: 0,
  });
  const getImgRotationInfo = ({
    radio = radio,
    imgInfo = imgInfo,
    angle = angle
  }) => {
    if (angle % 360 === 90) {  //  右
      setImgRotateInfo({
        rotation: 90,
        offsetX: 0,
        offsetY: imgInfo.height * radio
      })
    } else if (angle % 360 === 270) { //  左
      setImgRotateInfo({
        rotation: -90,
        offsetX: imgInfo.width * radio,
        offsetY: 0
      })
    } else if (angle % 360 === 0 || angle % 360 === 360) {  //  上
      setImgRotateInfo({
        rotation: 0,
        offsetX: 0,
        offsetY: 0,
      })
    } else if (angle % 360 === 180) {  // 下
      setImgRotateInfo({
        rotation: -180,
        offsetX: imgInfo.width * radio,
        offsetY: imgInfo.height * radio
      })
    }
  }

  const handleGetHtmlPosition = (top,left,curDeg)=>{
    let _top = top;
    let _left = left;
    if (curDeg / 90 % 4 === 1 || curDeg / 90 % 4 === -3) {  //  右
      _top = left;
      _left = -1 * top
    } else if (curDeg / 90 % 4 == 3 || curDeg / 90 % 4 == -1) { //  左
      _top = -1 *  left;
      _left = top;
    } else if (curDeg / 90 % 4 === 0) {  //  上
      
    } else if (curDeg / 90 % 4 === 2 || curDeg / 90 % 4 === -2) {  // 下
      _top = -1 *  top;
      _left = -1 *  left;
    }
    return {
      top:_top + 'px',
      left:_left + 'px'
    }
  }
  const handleGetStageInfo = ({
    curDeg = curDeg,
    angle = angle,
    targetWidth = targetWidth,
    targetHeight = targetHeight,
    radio = radio,
    imgInfo = imgInfo
  }) => {
    // TODO: 针对pdf需要判断高度是height还是targetHeight
    let _stageInfo;
    if (isImgHorizontal(curDeg + angle)) {
      _stageInfo = {
        width: targetHeight,
        height: imgInfo.width * radio,
      }
    } else {
      _stageInfo = {
        width: imgInfo.width * radio,
        height: targetHeight
      }
    }
    setStageInfo(_stageInfo)
    getRectRotationInfo({
      curDeg,
      angle,
      imgInfo,
      targetWidth,
      targetHeight,
      radio,
      stageInfo: _stageInfo
    });
  }
  const getRectRotationInfo = ({
    curDeg = curDeg,
    angle = angle,
    targetWidth = targetWidth,
    targetHeight = targetHeight,
    radio = radio,
    imgInfo = imgInfo,
    stageInfo = stageInfo
  }) => {
    if (curDeg / 90 % 4 === 1 || curDeg / 90 % 4 === -3) {  //  右
      setRotateInfo({
        rotation: 90,
        offsetX: 0,
        offsetY: stageInfo.width
      })
    } else if (curDeg / 90 % 4 == 3 || curDeg / 90 % 4 == -1) { //  左
      setRotateInfo({
        rotation: -90,
        offsetX: stageInfo.height,
        offsetY: 0
      })
    } else if (curDeg / 90 % 4 === 0) {  //  上
      setRotateInfo({
        rotation: 0,
        offsetX: 0,
        offsetY: 0,
      })
    } else if (curDeg / 90 % 4 === 2 || curDeg / 90 % 4 === -2) {  // 下
      setRotateInfo({
        rotation: -180,
        offsetX: stageInfo.width,
        offsetY: stageInfo.height
      })
    }
  }

  const scrollToPage = (currentPage) => {
     if (imageList?.length <= 0) return;
      scrollToTarget(currentPage);
      setInputVal(currentPage);
  }

  const getMargin = () => {
    let marginLeft = 0;
    let marginTop = 0;
    let _stageWidth = stageInfo.width * (sizes.width / 100)
    let _stageHeight = stageInfo.height * (sizes.width / 100)
    let containerWidth = imageBoxRef?.current.clientWidth
    let containerHeight = imageBoxRef?.current.clientHeight
    if( _stageWidth  > containerWidth){
      marginLeft = (_stageWidth - containerWidth) /2
    }
    if( _stageHeight  > containerHeight){
      marginTop = (_stageHeight - containerHeight) /2
    }
    return {
      marginLeft:marginLeft,
      marginTop:marginTop
    }
  }

  const handleFindCurRect = async (selectRect,rects) => {
        let _imageUrl = imageList?.length > 0 ? imageList[0] : imageUrl;
        if(!_imageUrl) return ;
        let curRect = rects.find((rect) => rect.key == selectRect)         
        if (curRect) {
          let pageNum = curRect.pageNum || 1
          setCurrentPage(pageNum);
          setInputVal(pageNum);
          scrollToTarget(pageNum);
          if (needClip) {
            // 当前仅支持第一页输出
            const imageBase64 = await cropToBase64(_imageUrl, [
              { x: curRect.points[0], y: curRect.points[1] }, // 左上
              { x: curRect.points[2], y: curRect.points[3] }, // 右上
              { x: curRect.points[4], y: curRect.points[5] }, // 右下
              { x: curRect.points[6], y: curRect.points[7] }   // 左下
            ],curImgSize)
            imageBase64 && onClip({
              img: imageBase64,
              curRect
            });
          }
        }
  }

  useEffect(() => {
    async function func() {
        if (!selectRect || rects.length <= 0) return;
        handleFindCurRect(selectRect,rects);
    }
    func();
  }, [selectRect]);

  // 同步更新ref的值
  useEffect(() => {
    containerImgInfoRef.current = containerImgInfo;
  }, [containerImgInfo]);

   // 同步更新ref的值
  useEffect(() => {
    imgListRef.current = imgList;
  }, [imgList]);

  useEffect(() => {
    sizesRef.current = sizes;
  }, [sizes]);

  const handleSetScrollPage = () => {
     if (!imageBoxRef.current || imgListRef.current.length < 1) return;
    
      const scrollElement = imageBoxRef.current;
      // setCurrentPage
      const pageHeight =  containerImgInfoRef.current.height * (sizesRef.current.width / 100) + 10 ;

      const scrollPage = Math.ceil(scrollElement.scrollTop / pageHeight) + 1
      const finishPage = scrollPage > imgListRef.current.length ? imgListRef.current.length : scrollPage
      // 使用ref访问最新的state值，避免闭包问题
      console.log('滚动位置信息Top:', 'imgList',imgListRef.current,'pageHeight',pageHeight,'scrollTop',scrollElement.scrollTop,finishPage);
      setCurrentPage(finishPage || currentPage || 1);
      setInputVal(finishPage || currentPage || 1);
      // 例如：根据滚动位置更新UI状态等
  }

  // 添加滚动位置监听
  useEffect(() => {
    // 防抖函数
    const debounce = (func, delay) => {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(this, args), delay);
      };
    };

    const handleScroll = () => {
      handleSetScrollPage();
    };

    // 创建防抖版本的handleScroll，延迟100ms
    const debouncedHandleScroll = debounce(handleScroll, 100);

    const scrollElement = imageBoxRef.current;
    if (scrollElement) {
      scrollElement.addEventListener('scroll', debouncedHandleScroll, { passive: true });
      
      // 初始触发一次，获取初始滚动位置
      handleScroll();
    }

    return () => {
      if (scrollElement) {
        scrollElement.removeEventListener('scroll', debouncedHandleScroll);
      }
    };
  }, []);

  useEffect(() => {
    async function func() {
      // eduAgent自动选择第一项
      if (rects.length <= 0) return;
      if(needClip){
        onSelect(rects[0].key)
      }
    }
    func();
  }, [rects]);

  useEffect(() => {
    handleGetStageInfo({
      curDeg,
      angle,
      imgInfo,
      targetWidth,
      targetHeight,
      radio,
    });
  }, [curDeg]);

  function isImgHorizontal(angle) {
    const normalizedDeg = angle % 360;
    if (Math.abs(normalizedDeg / 90 % 4) === 1 || Math.abs(normalizedDeg / 90 % 4) === 3) {
      return 'horizontal'; // 横向
    } else {
      return false; // 纵向
    }
  }

  async function handleSetStageWidth({imageUrl, imageList, imgSize,sizes, imageBoxRef, curDeg}) {
    const curImg = imageList?.length > 0 ? imageList[0].ImageUrl : imageUrl;
    if (!curImg ) {
      setIsError(true);
      return;
    }
    setImgList([]);
    try {
      let _containerWidth = imageBoxRef?.clientWidth
      let _containerHeight = imageBoxRef?.clientHeight
      setSizes(sizes);
      setIsError(false);
      let isPdf = imageList?.length > 0;
      let _imageList = imageList?.length > 0 ? imageList : [{
        ImageUrl:imageUrl
      }];
      setShowPdfPageControl(imageList?.length > 1);
      let NaturalImgInfo = imgSize ? imgSize : await getImgNatural(curImg, isPdf);
      setImgInfo(NaturalImgInfo)

      // 只取第一张用于计算图片尺寸
      const result = getScaleRatio({
        ImageBox: {
          h: _containerHeight,
          w: _containerWidth,
        },
        Image: {//  TODO: 根据初始方向计算缩放比例
          h: isImgHorizontal(curDeg) ? NaturalImgInfo.width : NaturalImgInfo.height,
          w: isImgHorizontal(curDeg) ? NaturalImgInfo.height : NaturalImgInfo.width
        },
      });
      setRadio(result.Ratio);

      let ImgList = _imageList.map(img => {
        let _width = result.Ratio * NaturalImgInfo.width;
        let _height = result.Ratio * NaturalImgInfo.height;
        return {
          ...img,
          src: img.ImageUrl,
          imgRadio: NaturalImgInfo.height ? NaturalImgInfo.height / img.Height   || 1 : 1,
          width: _width,
          height: _height
        }
      })
      setContainerImgInfo({
        width: result.Ratio * NaturalImgInfo.width,
        height: result.Ratio * NaturalImgInfo.height
      })
      ImgList = ImgList.map((i, index) => {
        return {
          ...i,
          x: 0,
          y: getSum(ImgList.slice(0, index).map(i => i.height)) + index * 8 || 0  //  pdf 之间间隔8
        }
      })
      let targetHeight = getSum(ImgList.map(i => i.height));
      let targetWidth = getSum(ImgList.map(i => i.width));
      setTotalPage(ImgList.length);
      setImgList(ImgList);
      handleGetStageInfo({
        curDeg,
        angle,
        targetWidth,
        targetHeight,
        radio: result.Ratio,
        imgInfo: NaturalImgInfo
      })
      getImgRotationInfo({
        radio: result.Ratio,
        imgInfo: NaturalImgInfo,
        angle
      });
      setTargetHeight(targetHeight);
      setTargetWidth(targetWidth);
    } catch (e) {
      console.log('size error', e)
      setIsError(true);
    }
  }

  const onDeg = (deg) => {
    let cur = curDeg + deg * 90
    setCurDeg(cur);
  }

  const onZoom = () => {
    handleSetStageWidth(
        {
          imageUrl:imageUrl,
          imageList:imageList,
          imgSize:curImgSize,
          sizes:{
            ...sizes,
            width: 100,
            height: 100,
            deg: 0,
          },
          imageBoxRef:imageBoxRef?.current,
          curDeg:curDeg
        })
        handleSetScrollPage();
  }

  const onZoomOut = () => {
    const newWidth = sizes.width - 10;
    if (newWidth > 20) {
      let newSizes = {
        ...sizes,
        width: newWidth,
        height: newWidth,
      }
      handleSetStageWidth(
        {
          imageUrl:imageUrl,
          imageList:imageList,
          imgSize:curImgSize,
          sizes:newSizes,
          imageBoxRef:imageBoxRef?.current,
          curDeg:curDeg
        })
        handleSetScrollPage();
    }
  };

  const onZoomIn = () => {
    const newWidth = sizes.width + 10;
    if (newWidth <= 180) {
      let newSizes = {
        ...sizes,
        width: newWidth,
        height: newWidth,
      }
      handleSetStageWidth(
        {
          imageUrl:imageUrl,
          imageList:imageList,
          imgSize:curImgSize,
          sizes:newSizes,
          imageBoxRef:imageBoxRef?.current,
          curDeg:curDeg
        })
        handleSetScrollPage();
    }
  };

  const errorIcon = (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect opacity="0.01" x="24" y="24" width="72" height="72" fill="white" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M30 84V36H90V84H30Z" fill="white" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M39 55.5H81V58.5H39V55.5Z" fill="#C1CCDD" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M39 66H69V69H39V66Z" fill="#C1CCDD" />
      <rect x="30" y="36" width="60" height="10.5" fill="#C1CCDD" />
      <rect opacity="0.01" x="72" y="66" width="30" height="30" fill="white" />
      <circle cx="87" cy="81" r="10.5" fill="white" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M87 69C80.373 69 75 74.373 75 81C75 87.627 80.373 93 87 93C93.627 93 99 87.627 99 81C99 74.373 93.627 69 87 69ZM88.5 87V84H85.5V87H88.5ZM88.5 75V82.5H85.5V75H88.5Z" fill="#006EFF" />
    </svg>
  );

  function scrollToTarget(target) {
    if (imgList?.length <= 0 || target < 0) return
    const currentScroll = imageBoxRef.current.scrollTop;
    let targetHeight = imgList[target - 1].y || 0;
    scrollTo(targetHeight - currentScroll)
  }
  return (
    <>
      {
        isError ?
          <div className={`unv-thumbnail-preview center ${isShow ? 'active' : 'hidden'}`} style={style} ref={imageBoxRef}>
            <div className="thumbnail-errorcontent">
              <div className="thumbnail-errorcontent__img">
                {errorIcon}
              </div>
              <div className="thumbnail-errorcontent__msg">
                {errorMsg}
              </div>
              <Button type="link" onClick={onUpload}>重新上传</Button>
            </div>
          </div> :
          <>
            <div
              className={`unv-thumbnail-preview ocr-thumbnail-preview ${isShow ? 'active' : 'hidden'}`}
              style={style} ref={imageBoxRef}
              id="imageBoxRef">
              <Stage
                ref={layerRef}
                height={stageInfo.height * (sizes.width / 100)}
                width={stageInfo.width * (sizes.width / 100)}
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform:`translate(-50%,-50%)`,
                  ...getMargin(),
                  // marginLeft: stageInfo.width * (sizes.width / 100) - imageBoxRef?.current.clientWidth > 0 ? 
                  width: stageInfo.width * (sizes.width / 100),
                  height: stageInfo.height * (sizes.width / 100)
                }}
              >
                <Layer
                  rotation={rotateInfo.rotation}
                  offsetX={rotateInfo.offsetX * (sizes.width / 100)}
                  offsetY={rotateInfo.offsetY * (sizes.width / 100)}
                >
                  {
                    imgList?.map((item, index) => {
                      return <LayerImage
                        key={index}
                        width={item.width * (sizes.width / 100)}
                        height={item.height * (sizes.width / 100)}
                        rotation={imgRotateInfo.rotation}
                        offsetX={imgRotateInfo.offsetX}
                        offsetY={imgRotateInfo.offsetY}
                        src={item.src}
                        y={item.y * (sizes.width / 100)}
                        x={item.x * (sizes.width / 100)}
                      />
                    })
                  }
                  {
                    !loading && rects.length > 0 && rects.map((rect, i) => (
                      <>
                        {
                          (needClip || showLabel) && rect?.points && <Html
                            className="htmlPoint"
                            parentNodeFunc={(args) => args.stage?.container()}
                            divProps={{
                              style: {
                                position: 'absolute',
                                width: '60px',
                                textAlign: 'center',
                                borderRadius:'3px',
                                ...handleGetHtmlPosition(rect.points[1] * (sizes.width / 100) * radio,rect.points[0] * (sizes.width / 100) * radio - 52,curDeg),
                                color: selectRect && rect.key && selectRect === rect.key ? '#fff' : rect.titleStyle?.activeColor || '#4A70FF',
                                background: selectRect && rect.key && selectRect === rect.key ? rect.titleStyle?.activeColor || '#4A70FF' : rect.titleStyle?.bgColor || '#AACFFF',
                              },
                            }}
                          >
                            <div className="edu-title">{rect.label}</div>
                          </Html>
                        }
                        {
                          showLabel && rect?.points && rect.IsCorrect !== undefined && <Html
                            className="htmlPoint isCorrectIcon"
                            parentNodeFunc={(args) => args.stage?.container()}
                            divProps={{
                              style: {
                                position: 'absolute',
                                width: '16px',
                                height: '16px',
                                textAlign: 'center',
                                ...handleGetHtmlPosition(rect.points[5] * (sizes.width / 100) * radio - 16, rect.points[4] * (sizes.width / 100) * radio -16, curDeg),
                              },
                            }}
                          >
                            <div className={`edu-correct-icon small ${rect.IsCorrect ? 'correct' : 'error'}`}></div>
                          </Html>
                        }
                        {
                        rect.points && <Line
                          key={i}
                          onClick={async () => {
                            if (rect.cantSelect) return
                            onSelect && onSelect(rect.key);
                          }}
                          points={rect.points.map((i, index) => {
                            let pageNum = rect.pageNum || 1
                            let pageRadio = imgList[pageNum - 1]?.imgRadio || 1 ;                            
                            if (index % 2 === 0) {
                              return i * (sizes.width / 100) * radio * pageRadio
                            } else {
                              return imgList[pageNum - 1]?.y * (sizes.width / 100) + i * (sizes.width / 100) * radio * pageRadio
                            }
                          })}
                          fill={selectRect && rect.key && selectRect === rect.key ? (rect.activeFill || 'rgba(0, 110, 255, 0.12)') : (rect.fill || 'transparent')}
                          stroke={selectRect && rect.key && selectRect === rect.key ? (rect.activeStoke || '#4A70FF') : (rect.stroke || '#AACFFF')}
                          strokeWidth={selectRect && rect.key && selectRect === rect.key ? rect.activeStrokeWidth || 2 : rect.stokeWidth || 1}
                          closed={true}
                        ></Line>
                        }

                        
                      </>
                    ))
                  }
                </Layer>
              </Stage>
            </div>
            <div className={`unv-thumbnail-preview__toolbar`} style={{ right: `calc(50% - ${showPdfPageControl ? '121px' : '48px'})` }}>
              {
                showPdfPageControl && <div className={`unv-thumbnail-preview__toolbar__pdfpreview`}>
                  <Icon className={`pre ${currentPage <= 1 ? 'disable' : ''}`} name="direction-bottom" onClick={() => {
                    if (currentPage <= 1) {
                      setCurrentPage(1);
                      scrollToPage(1);
                    } else {
                      setCurrentPage(Number(currentPage) - 1);
                      scrollToPage(Number(currentPage) - 1);
                    }
                  }} />
                  <span className={`currentPage`}>
                    <Input value={inputVal}
                      style={{ width: '32px' }}
                      onKeyUp={(e) => {
                        if (e.keyCode === 13) {
                          if (!NumberReg.test(inputVal)) {
                            setInputVal(currentPage);
                            return;
                          };
                          if (inputVal > totalPage) {
                            setCurrentPage(totalPage)
                            scrollToPage(totalPage);
                          } else if (inputVal <= 1) {
                            setCurrentPage(1);
                            scrollToPage(1);
                          } else {
                            setCurrentPage(inputVal);
                            scrollToPage(inputVal);
                          }
                        }
                      }}
                      onBlur={
                        (e) => {
                          if (!NumberReg.test(inputVal)) {
                            setInputVal(Number(currentPage));
                            return
                          };
                          if (inputVal > totalPage) {
                            setCurrentPage(totalPage);
                            scrollToPage(totalPage);
                          } else if (inputVal <= 1) {
                            setCurrentPage(1);
                            scrollToPage(1);
                          } else {
                            setCurrentPage(Number(inputVal));
                            scrollToPage((Number(inputVal)));
                          }
                        }
                      }
                      onChange={(e) => {
                        // if (!NumberReg.test(e.target.value)) return;
                        setInputVal(e.target.value);
                      }} />
                  </span>
                  <span className={`split`} >/</span>
                  <span className={`totalPage`}>{totalPage}</span>
                  <Icon className={`next ${currentPage >= totalPage ? 'disable' : ''}`} name="direction-bottom" onClick={() => {
                    if (currentPage >= totalPage) {
                      setCurrentPage(totalPage);
                      scrollToPage(totalPage);
                    } else {
                      setCurrentPage(Number(currentPage) + 1)
                      scrollToPage(Number(currentPage) + 1);
                    }
                  }} />
                </div>
              }
              {showZoomInIcon && <Tooltip content="放大" theme="light">
                <div style={{ marginRight: '8px' }} className={`ocrDemo-icon ocrDemo-icon-zoomInIcon ${sizes.width >= 180 ? 'disabled' : ''}`} onClick={onZoomIn}></div>
              </Tooltip>
              }
              {showZoomOutIcon && <Tooltip content="缩小" theme="light">
                <div style={{ marginRight: '16px' }} className={`ocrDemo-icon ocrDemo-icon-onZoomOut ${sizes.width <= 30 ? 'disabled' : ''}`} onClick={onZoomOut}></div>
              </Tooltip>}
              {showLeftIcon && <Tooltip content="向左旋转90度" theme="light">
                <div style={{ marginRight: '8px' }} className={`ocrDemo-icon ocrDemo-icon-leftIcon`} onClick={() => onDeg(-1)}></div>
              </Tooltip>}
              {showRightIcon && <Tooltip content="向右旋转90度" theme="light">
                <div style={{ marginRight: '16px' }} className={`ocrDemo-icon ocrDemo-icon-rightIcon`} onClick={() => onDeg(1)}></div>
              </Tooltip>}
              {showZoomIcon && <Tooltip content="快速还原" theme="light">
                <div className={`ocrDemo-icon ocrDemo-icon-onZoom ${sizes.width == 100 ? 'disabled' : ''}`} onClick={() => onZoom()}></div>
              </Tooltip>}
            </div>
          </>
      }
      {(isLoading || loading  ) && resultingCom()}

    </>
  );
};
ThumbnailPreview.defaultProps = {
};

export default ThumbnailPreview;
